module.exports = __webpack_public_path__ + "static/q17_x-804d48ac0e5cd9235dcdd6e3c88e67f5.png";